import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="ft-wrapper">
      
      <div className="ft-grid">

        {/* FAQ COLUMN */}
        <div className="ft-col">
          <h4 className="ft-title">FAQs</h4>

          <p className="ft-q">How can I earn from the platform?</p>
          <p className="ft-a">
            You can earn with multiple ways on the platform: solving puzzles, doing micro tasks and inviting your friends to the platform.
          </p>

          <p className="ft-q">Does the platform charge any fee for deposit or withdraw?</p>
          <p className="ft-a">
            The fees depend on your payment method. Platform does not charge any fee.
          </p>

          <p className="ft-q">How to solve puzzles?</p>
          <p className="ft-a">
            You can solve puzzles in an easy way — there are simple puzzles to solve.
          </p>

          <p className="ft-q">Is the platform strict?</p>
          <p className="ft-a">
            No, our platform is not strict. We provide a user-friendly interface to ensure users feel better and earn with us.
          </p>
        </div>

        {/* CONTACT INFO */}
        <div className="ft-col">
          <h4 className="ft-title">Contact Info</h4>

          <p className="ft-a"></p>
          <p className="ft-a">Support: supportmintiq@proton.me</p>
        </div>

        {/* LICENSE INFO */}
        <div className="ft-col">
          <h4 className="ft-title">License</h4>

          <p className="ft-a">
            Fully registered and regulated under UK Business Act.
          </p>
          <p className="ft-a">
            
          </p>
        </div>

        {/* ADDRESS */}
        <div className="ft-col">
          <h4 className="ft-title">Physical Address</h4>

          <p className="ft-a">Building Number: 460</p>
          <p className="ft-a">Street Name: Hyde Park Corner</p>
          <p className="ft-a">Wellington Arch</p>
          <p className="ft-a">City: London</p>
          <p className="ft-a">Post Code: SW1X 7TA</p>
          <p className="ft-a">Registered in UK</p>
        </div>

      </div>

      {/* COPYRIGHT */}
      <div className="ft-copy">
        © 2025 MintIQ — All rights reserved.
      </div>
    </footer>
  );
}
